import { render, staticRenderFns } from "./BottleSizeUpdate.vue?vue&type=template&id=4a7b8a23"
import script from "./BottleSizeUpdate.vue?vue&type=script&lang=ts"
export * from "./BottleSizeUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports